import { render, staticRenderFns } from "./text-popup.vue?vue&type=template&id=f243d35a&"
import script from "./text-popup.vue?vue&type=script&lang=js&"
export * from "./text-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports